<template>
  <section>
    <div class="row">
      <div ref="messages" class="col-lg-6 offset-lg-3 col-12 container-chat-booking chat-messages">
        <div v-if="articleData">
          <h3 class="pt-3 px-4">
            <router-link to="/article/category" class="text-primary">
              <i class="fas fa-home"></i>
              หน้าแรก
            </router-link>
            /
            <span v-html="articleData.title"></span>
          </h3>
          <section v-if="articles.length > 0">
            <div class="row mt-4">
              <div class="col-12" v-for="(article, index) in articles">
                <a class="no-style" :href="article.url">
                  <div class="card shadow-sm">
                    <div class="card-horizontal">
                      <div class="card-body">
                        <div class="card-title">{{ article.title }}</div>
                        <div class="text-remark mt-2">{{ article.date_published | prettyDate }}</div>
                      </div>
                      <div class="img-square-wrapper">
                        <div v-lazy:background-image="getImageUrl(article.content_html)"
                             class="card-image rounded-right"></div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </div>
            <div class="row" v-if="hasLoadMore">
              <div class="col">
                <button class="btn btn-block btn-outline-info" @click="loadMore()">โหลดเพิ่ม</button>
              </div>
            </div>
          </section>
          <div class="row p-5" v-else>
            <div class="col text-center text-secondary">
              <div class="mb-4"><i class="fal fa-frown fa-4x"></i></div>
              <h2>ยังไม่มีบทความ</h2>
            </div>
          </div>
        </div>
        <div v-else>
          <loader/>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import axios from 'axios'
  import Loader from '../loader/Loader'

  export default {
    components: {
      Loader
    },
    data () {
      return {
        articleData: null,
        selectedCategory: null,
        page: 1,
        articles: [],
        hasLoadMore: true
      }
    },
    methods: {
      async fetchArticles () {
        try {
          const url = `https://blog.beneat.co/category/${this.selectedCategory}/feed/json?paged=${this.page}`
          let { data } = await axios.get(url, {
            transformRequest: [(data, headers) => {
              delete headers.Authorization
              return data
            }]
          })
          this.articleData = data
          this.articles = this.articles.concat(data.items)
          this.hasLoadMore = (data.items.length >= 10)
        } catch (err) {
          this.hasLoadMore = false
        }
      },
      loadMore () {
        this.page += 1
        this.fetchArticles()
      },
      getImageUrl (content) {
        let src = 'http://via.placeholder.com/200x150'
        if (content) {
          const reg = /(src="[^"]*)(?=")/g
          const found = content.match(reg)
          if (found && found[0]) {
            src = found[0].replace('src="', '')
          }
        }
        return src
      }
    },
    mounted () {
      this.selectedCategory = this.$route.params.name
      this.fetchArticles()
    }
  }
</script>

<style scoped>
  .card-horizontal {
    display: flex;
    flex: 1 1 auto;
    height: 140px;
  }

  .card-image {
    width: 160px;
    height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }

  .card-title {
    font-size: 110%;
  }

  .text-remark {
    font-size: 80%;
  }

  @media screen and (max-width: 700px) {
    .card-horizontal {
      height: auto;
    }

    .card-image {
      width: 100px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/article/Article.vue